


















































































import { Component, Vue } from 'vue-property-decorator'
import IconSyncData from '@/app/ui/assets/badge_popup_sync_data.vue'
import IconLogout from '@/app/ui/assets/ics_o_logout.vue' 
import { Utils } from '@/app/infrastructures/misc'
import Button from '@/app/ui/components/Button/index.vue'
import controller from '@/app/ui/controllers/DeviceManagerController'
import { DeviceManager } from '@/domain/entities/DeviceManager'
import Modal from '@/app/ui/components/Modal/index.vue'
import iconConfirmation from '@/app/ui/assets/icon_confirmation.vue'
import LoadingOverlay from '@/app/ui/components/LoadingOverlay/index.vue'

@Component({
  components: {
    IconSyncData,
    IconLogout,
    Button,
    Modal,
    iconConfirmation,
    LoadingOverlay
  },
})
export default class DeviceManagerPage extends Vue {
  controller = controller
  logoutConfirmationModal = false
  deviceName = ""
  logoutId = 0

  created() {
    controller.getList();
  }

  get isLoading(): boolean {
    return controller.isLoading;
  }

  get listDeviceManager(): DeviceManager[] {
    return this.controller.deviceManager;
  }
  
  get currentDeviceId(): string {
    return Utils.getBrowserName() + `_${Utils.getDeviceId()}` 
  }

  openConfirmationLogoutModal(id = 0, deviceName = "", deviceOs = "") {
    this.logoutConfirmationModal = true
    this.logoutId = id
    this.deviceName = `${deviceName} (${deviceOs})`
  }

  private async logout() {
    const logout = await controller.logout(this.logoutId);
    this.logoutConfirmationModal = false;
    if (logout) {
      controller.getList();
      this.$toast("Perangkat berhasil dikeluarkan");
    }
  }

  formatDate(date: string) {
    const input = new Date(date);
    const now = new Date();

    const inputDateOnly = new Date(input.getFullYear(), input.getMonth(), input.getDate());
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);

    if (!date) {
      return "-"
    }

    if (inputDateOnly.getTime() === today.getTime()) {
      return `hari ini, ${Utils.formatTimeZone(Utils.formatDateWithIDLocale(date, 'HH:mm Z'))}`;
    }

    if (inputDateOnly.getTime() === yesterday.getTime()) {
      return `kemarin, ${Utils.formatTimeZone(Utils.formatDateWithIDLocale(date, 'HH:mm Z'))}`;
    }
    
    return Utils.formatTimeZone(Utils.formatDateWithIDLocale(date))
  }
}
